import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
}; // src/index.tsx


import React, { useRef, useEffect, useState } from "react"; // src/third-party/qrcodegen/index.ts

/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */

var qrcodegen;

(function (qrcodegen2) {
  var _QrCode = /*#__PURE__*/function () {
    function _QrCode(version, errorCorrectionLevel, dataCodewords, msk) {
      _classCallCheck(this, _QrCode);

      this.version = version;
      this.errorCorrectionLevel = errorCorrectionLevel;
      this.modules = [];
      this.isFunction = [];
      if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
      if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
      this.size = version * 4 + 17;
      var row = [];

      for (var i = 0; i < this.size; i++) {
        row.push(false);
      }

      for (var _i = 0; _i < this.size; _i++) {
        this.modules.push(row.slice());
        this.isFunction.push(row.slice());
      }

      this.drawFunctionPatterns();
      var allCodewords = this.addEccAndInterleave(dataCodewords);
      this.drawCodewords(allCodewords);

      if (msk == -1) {
        var minPenalty = 1e9;

        for (var _i2 = 0; _i2 < 8; _i2++) {
          this.applyMask(_i2);
          this.drawFormatBits(_i2);
          var penalty = this.getPenaltyScore();

          if (penalty < minPenalty) {
            msk = _i2;
            minPenalty = penalty;
          }

          this.applyMask(_i2);
        }
      }

      assert(0 <= msk && msk <= 7);
      this.mask = msk;
      this.applyMask(msk);
      this.drawFormatBits(msk);
      this.isFunction = [];
    }

    _createClass(_QrCode, [{
      key: "getModule",
      value: function getModule(x, y) {
        return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
      }
    }, {
      key: "getModules",
      value: function getModules() {
        return this.modules;
      }
    }, {
      key: "drawFunctionPatterns",
      value: function drawFunctionPatterns() {
        for (var i = 0; i < this.size; i++) {
          this.setFunctionModule(6, i, i % 2 == 0);
          this.setFunctionModule(i, 6, i % 2 == 0);
        }

        this.drawFinderPattern(3, 3);
        this.drawFinderPattern(this.size - 4, 3);
        this.drawFinderPattern(3, this.size - 4);
        var alignPatPos = this.getAlignmentPatternPositions();
        var numAlign = alignPatPos.length;

        for (var _i3 = 0; _i3 < numAlign; _i3++) {
          for (var j = 0; j < numAlign; j++) {
            if (!(_i3 == 0 && j == 0 || _i3 == 0 && j == numAlign - 1 || _i3 == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[_i3], alignPatPos[j]);
          }
        }

        this.drawFormatBits(0);
        this.drawVersion();
      }
    }, {
      key: "drawFormatBits",
      value: function drawFormatBits(mask) {
        var data = this.errorCorrectionLevel.formatBits << 3 | mask;
        var rem = data;

        for (var i = 0; i < 10; i++) {
          rem = rem << 1 ^ (rem >>> 9) * 1335;
        }

        var bits = (data << 10 | rem) ^ 21522;
        assert(bits >>> 15 == 0);

        for (var _i4 = 0; _i4 <= 5; _i4++) {
          this.setFunctionModule(8, _i4, getBit(bits, _i4));
        }

        this.setFunctionModule(8, 7, getBit(bits, 6));
        this.setFunctionModule(8, 8, getBit(bits, 7));
        this.setFunctionModule(7, 8, getBit(bits, 8));

        for (var _i5 = 9; _i5 < 15; _i5++) {
          this.setFunctionModule(14 - _i5, 8, getBit(bits, _i5));
        }

        for (var _i6 = 0; _i6 < 8; _i6++) {
          this.setFunctionModule(this.size - 1 - _i6, 8, getBit(bits, _i6));
        }

        for (var _i7 = 8; _i7 < 15; _i7++) {
          this.setFunctionModule(8, this.size - 15 + _i7, getBit(bits, _i7));
        }

        this.setFunctionModule(8, this.size - 8, true);
      }
    }, {
      key: "drawVersion",
      value: function drawVersion() {
        if (this.version < 7) return;
        var rem = this.version;

        for (var i = 0; i < 12; i++) {
          rem = rem << 1 ^ (rem >>> 11) * 7973;
        }

        var bits = this.version << 12 | rem;
        assert(bits >>> 18 == 0);

        for (var _i8 = 0; _i8 < 18; _i8++) {
          var color = getBit(bits, _i8);
          var a = this.size - 11 + _i8 % 3;
          var b = Math.floor(_i8 / 3);
          this.setFunctionModule(a, b, color);
          this.setFunctionModule(b, a, color);
        }
      }
    }, {
      key: "drawFinderPattern",
      value: function drawFinderPattern(x, y) {
        for (var dy = -4; dy <= 4; dy++) {
          for (var dx = -4; dx <= 4; dx++) {
            var dist = Math.max(Math.abs(dx), Math.abs(dy));
            var xx = x + dx;
            var yy = y + dy;
            if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
          }
        }
      }
    }, {
      key: "drawAlignmentPattern",
      value: function drawAlignmentPattern(x, y) {
        for (var dy = -2; dy <= 2; dy++) {
          for (var dx = -2; dx <= 2; dx++) {
            this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
          }
        }
      }
    }, {
      key: "setFunctionModule",
      value: function setFunctionModule(x, y, isDark) {
        this.modules[y][x] = isDark;
        this.isFunction[y][x] = true;
      }
    }, {
      key: "addEccAndInterleave",
      value: function addEccAndInterleave(data) {
        var ver = this.version;
        var ecl = this.errorCorrectionLevel;
        if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
        var numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        var blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
        var rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
        var numShortBlocks = numBlocks - rawCodewords % numBlocks;
        var shortBlockLen = Math.floor(rawCodewords / numBlocks);
        var blocks = [];

        var rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);

        for (var i = 0, k = 0; i < numBlocks; i++) {
          var dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
          k += dat.length;

          var ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);

          if (i < numShortBlocks) dat.push(0);
          blocks.push(dat.concat(ecc));
        }

        var result = [];

        var _loop = function _loop(_i9) {
          blocks.forEach(function (block, j) {
            if (_i9 != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[_i9]);
          });
        };

        for (var _i9 = 0; _i9 < blocks[0].length; _i9++) {
          _loop(_i9);
        }

        assert(result.length == rawCodewords);
        return result;
      }
    }, {
      key: "drawCodewords",
      value: function drawCodewords(data) {
        if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
        var i = 0;

        for (var right = this.size - 1; right >= 1; right -= 2) {
          if (right == 6) right = 5;

          for (var vert = 0; vert < this.size; vert++) {
            for (var j = 0; j < 2; j++) {
              var x = right - j;
              var upward = (right + 1 & 2) == 0;
              var y = upward ? this.size - 1 - vert : vert;

              if (!this.isFunction[y][x] && i < data.length * 8) {
                this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                i++;
              }
            }
          }
        }

        assert(i == data.length * 8);
      }
    }, {
      key: "applyMask",
      value: function applyMask(mask) {
        if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");

        for (var y = 0; y < this.size; y++) {
          for (var x = 0; x < this.size; x++) {
            var invert = void 0;

            switch (mask) {
              case 0:
                invert = (x + y) % 2 == 0;
                break;

              case 1:
                invert = y % 2 == 0;
                break;

              case 2:
                invert = x % 3 == 0;
                break;

              case 3:
                invert = (x + y) % 3 == 0;
                break;

              case 4:
                invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                break;

              case 5:
                invert = x * y % 2 + x * y % 3 == 0;
                break;

              case 6:
                invert = (x * y % 2 + x * y % 3) % 2 == 0;
                break;

              case 7:
                invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                break;

              default:
                throw new Error("Unreachable");
            }

            if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
          }
        }
      }
    }, {
      key: "getPenaltyScore",
      value: function getPenaltyScore() {
        var result = 0;

        for (var y = 0; y < this.size; y++) {
          var runColor = false;
          var runX = 0;
          var runHistory = [0, 0, 0, 0, 0, 0, 0];

          for (var x = 0; x < this.size; x++) {
            if (this.modules[y][x] == runColor) {
              runX++;
              if (runX == 5) result += _QrCode.PENALTY_N1;else if (runX > 5) result++;
            } else {
              this.finderPenaltyAddHistory(runX, runHistory);
              if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
              runColor = this.modules[y][x];
              runX = 1;
            }
          }

          result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
        }

        for (var _x = 0; _x < this.size; _x++) {
          var _runColor = false;
          var runY = 0;
          var _runHistory = [0, 0, 0, 0, 0, 0, 0];

          for (var _y = 0; _y < this.size; _y++) {
            if (this.modules[_y][_x] == _runColor) {
              runY++;
              if (runY == 5) result += _QrCode.PENALTY_N1;else if (runY > 5) result++;
            } else {
              this.finderPenaltyAddHistory(runY, _runHistory);
              if (!_runColor) result += this.finderPenaltyCountPatterns(_runHistory) * _QrCode.PENALTY_N3;
              _runColor = this.modules[_y][_x];
              runY = 1;
            }
          }

          result += this.finderPenaltyTerminateAndCount(_runColor, runY, _runHistory) * _QrCode.PENALTY_N3;
        }

        for (var _y2 = 0; _y2 < this.size - 1; _y2++) {
          for (var _x2 = 0; _x2 < this.size - 1; _x2++) {
            var color = this.modules[_y2][_x2];
            if (color == this.modules[_y2][_x2 + 1] && color == this.modules[_y2 + 1][_x2] && color == this.modules[_y2 + 1][_x2 + 1]) result += _QrCode.PENALTY_N2;
          }
        }

        var dark = 0;

        var _iterator3 = _createForOfIteratorHelper(this.modules),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var row = _step3.value;
            dark = row.reduce(function (sum, color) {
              return sum + (color ? 1 : 0);
            }, dark);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var total = this.size * this.size;
        var k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
        assert(0 <= k && k <= 9);
        result += k * _QrCode.PENALTY_N4;
        assert(0 <= result && result <= 2568888);
        return result;
      }
    }, {
      key: "getAlignmentPatternPositions",
      value: function getAlignmentPatternPositions() {
        if (this.version == 1) return [];else {
          var numAlign = Math.floor(this.version / 7) + 2;
          var step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
          var result = [6];

          for (var pos = this.size - 7; result.length < numAlign; pos -= step) {
            result.splice(1, 0, pos);
          }

          return result;
        }
      }
    }, {
      key: "finderPenaltyCountPatterns",
      value: function finderPenaltyCountPatterns(runHistory) {
        var n = runHistory[1];
        assert(n <= this.size * 3);
        var core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
        return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
      }
    }, {
      key: "finderPenaltyTerminateAndCount",
      value: function finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
        if (currentRunColor) {
          this.finderPenaltyAddHistory(currentRunLength, runHistory);
          currentRunLength = 0;
        }

        currentRunLength += this.size;
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        return this.finderPenaltyCountPatterns(runHistory);
      }
    }, {
      key: "finderPenaltyAddHistory",
      value: function finderPenaltyAddHistory(currentRunLength, runHistory) {
        if (runHistory[0] == 0) currentRunLength += this.size;
        runHistory.pop();
        runHistory.unshift(currentRunLength);
      }
    }], [{
      key: "encodeText",
      value: function encodeText(text, ecl) {
        var segs = qrcodegen2.QrSegment.makeSegments(text);
        return _QrCode.encodeSegments(segs, ecl);
      }
    }, {
      key: "encodeBinary",
      value: function encodeBinary(data, ecl) {
        var seg = qrcodegen2.QrSegment.makeBytes(data);
        return _QrCode.encodeSegments([seg], ecl);
      }
    }, {
      key: "encodeSegments",
      value: function encodeSegments(segs, ecl) {
        var minVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var maxVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 40;
        var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
        var boostEcl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
        if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
        var version;
        var dataUsedBits;

        for (version = minVersion;; version++) {
          var dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
          var usedBits = QrSegment.getTotalBits(segs, version);

          if (usedBits <= dataCapacityBits2) {
            dataUsedBits = usedBits;
            break;
          }

          if (version >= maxVersion) throw new RangeError("Data too long");
        }

        for (var _i10 = 0, _arr = [_QrCode.Ecc.MEDIUM, _QrCode.Ecc.QUARTILE, _QrCode.Ecc.HIGH]; _i10 < _arr.length; _i10++) {
          var newEcl = _arr[_i10];
          if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
        }

        var bb = [];

        var _iterator4 = _createForOfIteratorHelper(segs),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var seg = _step4.value;
            appendBits(seg.mode.modeBits, 4, bb);
            appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);

            var _iterator5 = _createForOfIteratorHelper(seg.getData()),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var b = _step5.value;
                bb.push(b);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        assert(bb.length == dataUsedBits);
        var dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
        assert(bb.length <= dataCapacityBits);
        appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
        appendBits(0, (8 - bb.length % 8) % 8, bb);
        assert(bb.length % 8 == 0);

        for (var padByte = 236; bb.length < dataCapacityBits; padByte ^= 236 ^ 17) {
          appendBits(padByte, 8, bb);
        }

        var dataCodewords = [];

        while (dataCodewords.length * 8 < bb.length) {
          dataCodewords.push(0);
        }

        bb.forEach(function (b, i) {
          return dataCodewords[i >>> 3] |= b << 7 - (i & 7);
        });
        return new _QrCode(version, ecl, dataCodewords, mask);
      }
    }, {
      key: "getNumRawDataModules",
      value: function getNumRawDataModules(ver) {
        if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
        var result = (16 * ver + 128) * ver + 64;

        if (ver >= 2) {
          var numAlign = Math.floor(ver / 7) + 2;
          result -= (25 * numAlign - 10) * numAlign - 55;
          if (ver >= 7) result -= 36;
        }

        assert(208 <= result && result <= 29648);
        return result;
      }
    }, {
      key: "getNumDataCodewords",
      value: function getNumDataCodewords(ver, ecl) {
        return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      }
    }, {
      key: "reedSolomonComputeDivisor",
      value: function reedSolomonComputeDivisor(degree) {
        if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
        var result = [];

        for (var i = 0; i < degree - 1; i++) {
          result.push(0);
        }

        result.push(1);
        var root = 1;

        for (var _i11 = 0; _i11 < degree; _i11++) {
          for (var j = 0; j < result.length; j++) {
            result[j] = _QrCode.reedSolomonMultiply(result[j], root);
            if (j + 1 < result.length) result[j] ^= result[j + 1];
          }

          root = _QrCode.reedSolomonMultiply(root, 2);
        }

        return result;
      }
    }, {
      key: "reedSolomonComputeRemainder",
      value: function reedSolomonComputeRemainder(data, divisor) {
        var result = divisor.map(function (_) {
          return 0;
        });

        var _iterator6 = _createForOfIteratorHelper(data),
            _step6;

        try {
          var _loop2 = function _loop2() {
            var b = _step6.value;
            var factor = b ^ result.shift();
            result.push(0);
            divisor.forEach(function (coef, i) {
              return result[i] ^= _QrCode.reedSolomonMultiply(coef, factor);
            });
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return result;
      }
    }, {
      key: "reedSolomonMultiply",
      value: function reedSolomonMultiply(x, y) {
        if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
        var z = 0;

        for (var i = 7; i >= 0; i--) {
          z = z << 1 ^ (z >>> 7) * 285;
          z ^= (y >>> i & 1) * x;
        }

        assert(z >>> 8 == 0);
        return z;
      }
    }]);

    return _QrCode;
  }();

  var QrCode = _QrCode;
  QrCode.MIN_VERSION = 1;
  QrCode.MAX_VERSION = 40;
  QrCode.PENALTY_N1 = 3;
  QrCode.PENALTY_N2 = 3;
  QrCode.PENALTY_N3 = 40;
  QrCode.PENALTY_N4 = 10;
  QrCode.ECC_CODEWORDS_PER_BLOCK = [[-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28], [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]];
  QrCode.NUM_ERROR_CORRECTION_BLOCKS = [[-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25], [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49], [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68], [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]];
  qrcodegen2.QrCode = QrCode;

  function appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");

    for (var i = len - 1; i >= 0; i--) {
      bb.push(val >>> i & 1);
    }
  }

  function getBit(x, i) {
    return (x >>> i & 1) != 0;
  }

  function assert(cond) {
    if (!cond) throw new Error("Assertion error");
  }

  var _QrSegment = /*#__PURE__*/function () {
    function _QrSegment(mode, numChars, bitData) {
      _classCallCheck(this, _QrSegment);

      this.mode = mode;
      this.numChars = numChars;
      this.bitData = bitData;
      if (numChars < 0) throw new RangeError("Invalid argument");
      this.bitData = bitData.slice();
    }

    _createClass(_QrSegment, [{
      key: "getData",
      value: function getData() {
        return this.bitData.slice();
      }
    }], [{
      key: "makeBytes",
      value: function makeBytes(data) {
        var bb = [];

        var _iterator7 = _createForOfIteratorHelper(data),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var b = _step7.value;
            appendBits(b, 8, bb);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
      }
    }, {
      key: "makeNumeric",
      value: function makeNumeric(digits) {
        if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
        var bb = [];

        for (var i = 0; i < digits.length;) {
          var n = Math.min(digits.length - i, 3);
          appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
          i += n;
        }

        return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
      }
    }, {
      key: "makeAlphanumeric",
      value: function makeAlphanumeric(text) {
        if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
        var bb = [];
        var i;

        for (i = 0; i + 2 <= text.length; i += 2) {
          var temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
          temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
          appendBits(temp, 11, bb);
        }

        if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
        return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
      }
    }, {
      key: "makeSegments",
      value: function makeSegments(text) {
        if (text == "") return [];else if (_QrSegment.isNumeric(text)) return [_QrSegment.makeNumeric(text)];else if (_QrSegment.isAlphanumeric(text)) return [_QrSegment.makeAlphanumeric(text)];else return [_QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))];
      }
    }, {
      key: "makeEci",
      value: function makeEci(assignVal) {
        var bb = [];
        if (assignVal < 0) throw new RangeError("ECI assignment value out of range");else if (assignVal < 1 << 7) appendBits(assignVal, 8, bb);else if (assignVal < 1 << 14) {
          appendBits(2, 2, bb);
          appendBits(assignVal, 14, bb);
        } else if (assignVal < 1e6) {
          appendBits(6, 3, bb);
          appendBits(assignVal, 21, bb);
        } else throw new RangeError("ECI assignment value out of range");
        return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
      }
    }, {
      key: "isNumeric",
      value: function isNumeric(text) {
        return _QrSegment.NUMERIC_REGEX.test(text);
      }
    }, {
      key: "isAlphanumeric",
      value: function isAlphanumeric(text) {
        return _QrSegment.ALPHANUMERIC_REGEX.test(text);
      }
    }, {
      key: "getTotalBits",
      value: function getTotalBits(segs, version) {
        var result = 0;

        var _iterator8 = _createForOfIteratorHelper(segs),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var seg = _step8.value;
            var ccbits = seg.mode.numCharCountBits(version);
            if (seg.numChars >= 1 << ccbits) return Infinity;
            result += 4 + ccbits + seg.bitData.length;
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return result;
      }
    }, {
      key: "toUtf8ByteArray",
      value: function toUtf8ByteArray(str) {
        str = encodeURI(str);
        var result = [];

        for (var i = 0; i < str.length; i++) {
          if (str.charAt(i) != "%") result.push(str.charCodeAt(i));else {
            result.push(parseInt(str.substr(i + 1, 2), 16));
            i += 2;
          }
        }

        return result;
      }
    }]);

    return _QrSegment;
  }();

  var QrSegment = _QrSegment;
  QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
  QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
  QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));

(function (qrcodegen2) {
  var QrCode;

  (function (QrCode2) {
    var _Ecc = /*#__PURE__*/_createClass(function _Ecc(ordinal, formatBits) {
      _classCallCheck(this, _Ecc);

      this.ordinal = ordinal;
      this.formatBits = formatBits;
    });

    var Ecc = _Ecc;
    Ecc.LOW = new _Ecc(0, 1);
    Ecc.MEDIUM = new _Ecc(1, 0);
    Ecc.QUARTILE = new _Ecc(2, 3);
    Ecc.HIGH = new _Ecc(3, 2);
    QrCode2.Ecc = Ecc;
  })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));

(function (qrcodegen2) {
  var QrSegment;

  (function (QrSegment2) {
    var _Mode = /*#__PURE__*/function () {
      function _Mode(modeBits, numBitsCharCount) {
        _classCallCheck(this, _Mode);

        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
      }

      _createClass(_Mode, [{
        key: "numCharCountBits",
        value: function numCharCountBits(ver) {
          return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
        }
      }]);

      return _Mode;
    }();

    var Mode = _Mode;
    Mode.NUMERIC = new _Mode(1, [10, 12, 14]);
    Mode.ALPHANUMERIC = new _Mode(2, [9, 11, 13]);
    Mode.BYTE = new _Mode(4, [8, 16, 16]);
    Mode.KANJI = new _Mode(8, [8, 10, 12]);
    Mode.ECI = new _Mode(7, [0, 0, 0]);
    QrSegment2.Mode = Mode;
  })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));

var qrcodegen_default = qrcodegen; // src/index.tsx

/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */

var ERROR_LEVEL_MAP = {
  L: qrcodegen_default.QrCode.Ecc.LOW,
  M: qrcodegen_default.QrCode.Ecc.MEDIUM,
  Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
  H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      }

      if (x === row.length - 1) {
        if (!cell) {
          return;
        }

        if (start === null) {
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join("");
}

function excavateModules(modules, excavation) {
  return modules.slice().map(function (row, y) {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }

    return row.map(function (cell, x) {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }

      return false;
    });
  });
}

function getImageSettings(cells, size, includeMargin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }

  var margin = includeMargin ? MARGIN_SIZE : 0;
  var numCells = cells.length + margin * 2;
  var defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  var scale = numCells / size;
  var w = (imageSettings.width || defaultSize) * scale;
  var h = (imageSettings.height || defaultSize) * scale;
  var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  var excavation = null;

  if (imageSettings.excavate) {
    var floorX = Math.floor(x);
    var floorY = Math.floor(y);
    var ceilW = Math.ceil(w + x - floorX);
    var ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }

  return {
    x: x,
    y: y,
    h: h,
    w: w,
    excavation: excavation
  };
}

var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

function QRCodeCanvas(props) {
  var _a = props,
      value = _a.value,
      _a$size = _a.size,
      size = _a$size === void 0 ? DEFAULT_SIZE : _a$size,
      _a$level = _a.level,
      level = _a$level === void 0 ? DEFAULT_LEVEL : _a$level,
      _a$bgColor = _a.bgColor,
      bgColor = _a$bgColor === void 0 ? DEFAULT_BGCOLOR : _a$bgColor,
      _a$fgColor = _a.fgColor,
      fgColor = _a$fgColor === void 0 ? DEFAULT_FGCOLOR : _a$fgColor,
      _a$includeMargin = _a.includeMargin,
      includeMargin = _a$includeMargin === void 0 ? DEFAULT_INCLUDEMARGIN : _a$includeMargin,
      style = _a.style,
      imageSettings = _a.imageSettings,
      otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "style", "imageSettings"]);

  var imgSrc = imageSettings == null ? void 0 : imageSettings.src;

  var _canvas = useRef(null);

  var _image = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isImgLoaded = _useState2[0],
      setIsImageLoaded = _useState2[1];

  useEffect(function () {
    if (_canvas.current != null) {
      var canvas = _canvas.current;
      var ctx = canvas.getContext("2d");

      if (!ctx) {
        return;
      }

      var cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
      var margin = includeMargin ? MARGIN_SIZE : 0;
      var numCells = cells.length + margin * 2;
      var calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
      var image = _image.current;
      var haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;

      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }

      var pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      var scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;

      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }

      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  useEffect(function () {
    setIsImageLoaded(false);
  }, [imgSrc]);

  var canvasStyle = __spreadValues({
    height: size,
    width: size
  }, style);

  var img = null;

  if (imgSrc != null) {
    img = /* @__PURE__ */React.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: {
        display: "none"
      },
      onLoad: function onLoad() {
        setIsImageLoaded(true);
      },
      ref: _image
    });
  }

  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("canvas", __spreadValues({
    style: canvasStyle,
    height: size,
    width: size,
    ref: _canvas
  }, otherProps)), img);
}

function QRCodeSVG(props) {
  var _a = props,
      value = _a.value,
      _a$size2 = _a.size,
      size = _a$size2 === void 0 ? DEFAULT_SIZE : _a$size2,
      _a$level2 = _a.level,
      level = _a$level2 === void 0 ? DEFAULT_LEVEL : _a$level2,
      _a$bgColor2 = _a.bgColor,
      bgColor = _a$bgColor2 === void 0 ? DEFAULT_BGCOLOR : _a$bgColor2,
      _a$fgColor2 = _a.fgColor,
      fgColor = _a$fgColor2 === void 0 ? DEFAULT_FGCOLOR : _a$fgColor2,
      _a$includeMargin2 = _a.includeMargin,
      includeMargin = _a$includeMargin2 === void 0 ? DEFAULT_INCLUDEMARGIN : _a$includeMargin2,
      imageSettings = _a.imageSettings,
      otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]);

  var cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
  var margin = includeMargin ? MARGIN_SIZE : 0;
  var numCells = cells.length + margin * 2;
  var calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
  var image = null;

  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cells = excavateModules(cells, calculatedImageSettings.excavation);
    }

    image = /* @__PURE__ */React.createElement("image", {
      xlinkHref: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none"
    });
  }

  var fgPath = generatePath(cells, margin);
  return /* @__PURE__ */React.createElement("svg", __spreadValues({
    height: size,
    width: size,
    viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
  }, otherProps), /* @__PURE__ */React.createElement("path", {
    fill: bgColor,
    d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z"),
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */React.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
}

var QRCode = function QRCode(props) {
  var _a = props,
      renderAs = _a.renderAs,
      otherProps = __objRest(_a, ["renderAs"]);

  if (renderAs === "svg") {
    return /* @__PURE__ */React.createElement(QRCodeSVG, __spreadValues({}, otherProps));
  }

  return /* @__PURE__ */React.createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};

export { QRCodeCanvas, QRCodeSVG, QRCode as default };